// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1txub","name":"styles_name__2BNkJ","phone":"styles_phone__19oHN"};